import styled from "@emotion/styled";
import Colors from "styles/colors";
import { BACKGROUND_GRAY_COLOR_NAME, SLATE_GRAY_COLOR_NAME, WHITE_COLOR_NAME } from "styles/color-consts";
import { TOP_BAR } from "constants/z-index";
import HeaderConstants from "segments/desktop/header/layouts/components/basic-header/constants";
export const StyledDropdown = styled.div`
  position: relative;

  .title {
    font-size: 1rem;
  }

  .dropdown-menu-button {
    position: relative;
    background: ${Colors[WHITE_COLOR_NAME]};
    border-radius: 8px;
    font-weight: normal;
    font-size: 0.8125rem;
    letter-spacing: -0.02em;
    color: ${Colors[SLATE_GRAY_COLOR_NAME]};
    border: 1px solid ${Colors.jaco};
    height: 40px;
    padding: 8px 32px 8px 16px;

    .selected-item {
      img {
        max-height: 20px;
        width: auto;
      }

      display: flex;
      align-items: center;
      gap: 8px;
    }

    .dropdown-icon,
    .remove-icon {
      position: absolute;
      display: flex;
      right: 12px;
      margin-left: auto;
      margin-right: auto;
      top: 50%;
      transform: translateY(-50%);

      svg {
        height: 0.5rem;
        width: 0.5rem;
      }
    }
  }

  .dropdown-menu {
    min-width: 12rem;
    height: fit-content;
    padding-top: 4px;
    position: absolute;
    z-index: ${TOP_BAR};
    right: 0;

    pointer-events: none;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;

    &.is-active {
      display: flex;
      opacity: 1;
      height: auto;
      pointer-events: all;
    }

    .dropdown-content {
      max-height: calc(100vh - ${HeaderConstants.BASIC_HEADER_HEIGHT}px - 94px);
      overflow: auto;
      background: ${Colors[WHITE_COLOR_NAME]};
      box-shadow: 0 4px 4px rgba(29, 140, 242, 0.25);
      border-radius: 8px;
      padding: 27px;
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 758px;

      .dropdown-title {
        font-size: 1rem;
        width: 100%;
        margin-bottom: 24px;
      }
    }
  }

  .dropdown-trigger.has-selection button {
    box-shadow: none;
    text-overflow: ellipsis;
    background: ${Colors[BACKGROUND_GRAY_COLOR_NAME]};

    .text {
      width: 84px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
`;
